import { render, staticRenderFns } from "./BgColumnEdited.vue?vue&type=template&id=0443d56d"
import script from "./BgColumnEdited.vue?vue&type=script&lang=js"
export * from "./BgColumnEdited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports